module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-column items-center justify-center w-100"
  }, [(_vm.index > 0) ? _c('div', {
    staticClass: "separation-line mt3 w-100"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt3 black flex flex-row w-100"
  }, [_c('div', {
    staticClass: "inter f6-ns gray-c mr2"
  }, [_vm._v("\n      #" + _vm._s(_vm.index + 1) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-column w-100"
  }, [_c('div', {
    staticClass: "flex flex-row flex-nowrap model-price justify-between cera-round-pro-medium items-baseline tl f6-ns w-100 text-line"
  }, [_c('div', {
    staticClass: "model"
  }, [_vm._v("\n          " + _vm._s(_vm.modelCount) + " " + _vm._s(_vm.deviceInfo.make) + " " + _vm._s(_vm.deviceInfo.model) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-wrap tr f6 price"
  }, [_vm._v("\n          $" + _vm._s(_vm.deviceInfo.price.toFixed(2)) + " / " + _vm._s(_vm.isMonthly ? 'month' : 'year') + " " + _vm._s(_vm.each) + "\n        ")])]), _vm._v(" "), (_vm.isCartInfo) ? _c('div', {
    staticClass: "mt1 flex flex-column justify-end items-start"
  }, [_c('div', {
    staticClass: "inter color-theme f7 mb1"
  }, [_vm._v("\n          " + _vm._s(_vm.deviceInfo.individualCoverageName) + "\n        ")]), _vm._v(" "), (!(_vm.isPhoneOnly || _vm.deviceInfo.adult)) ? _c('div', {
    staticClass: "inter gray-c f7 mb1"
  }, [_vm._v("\n          Student-Plan Discount Applied\n        ")]) : _vm._e()]) : _c('div', {
    staticClass: "mt3 flex flex-column items-start justify-start"
  }, [_c('div', {
    staticClass: "inter gray-c f7 mr2 mb1"
  }, [_vm._v("DEDUCTIBLES")]), _vm._v(" "), _c('div', {
    staticClass: "lh-copy gray-c fs7"
  }, [_vm._v("\n          $" + _vm._s(_vm.deviceInfo.screen_replacement_deductible) + " for Screen Replacement\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "lh-copy gray-c fs7"
  }, [_vm._v("\n          $" + _vm._s(_vm.deviceInfo.repair_deductible) + " for Other Repairs\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "lh-copy gray-c fs7"
  }, [_vm._v("\n          $" + _vm._s(_vm.deviceInfo.replacement_deductible) + " for Replacement or Theft\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c08555f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/multiplePhonePlan/summaryBox/DeviceInfo3c.vue
// module id = 722
// module chunks = 0